module.exports = __webpack_public_path__ + "img/labelmaker.85781615.png";